/* unplugin-vue-components disabled */import script from "./flowlist.vue?vue&type=script&setup=true&lang=js"
export * from "./flowlist.vue?vue&type=script&setup=true&lang=js"

import "./flowlist.vue?vue&type=style&index=0&id=6a6ec01a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a6ec01a"]])

export default __exports__